var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            title: _vm.fromData.title,
            visible: _vm.dialogVisible,
            width: "480px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "body" }, [
            _c(
              "div",
              { staticClass: "add-button" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: { click: _vm.openDepartment },
                  },
                  [_vm._v(_vm._s(_vm.$t("file.addsharedmembers")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("ul", { staticClass: "content-title" }, [
                _c("li", [
                  _c("p", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(_vm.$t("file.spacemember"))),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("public.download")))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("public.edit")))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("public.operation")))]),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("p", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(_vm.$t("file.batchsettings"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c("el-checkbox", {
                        attrs: { disabled: _vm.userList.length <= 0 },
                        on: { change: _vm.downloadChange },
                        model: {
                          value: _vm.downloadCheck,
                          callback: function ($$v) {
                            _vm.downloadCheck = $$v
                          },
                          expression: "downloadCheck",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c("el-checkbox", {
                        attrs: { disabled: _vm.userList.length <= 0 },
                        on: { change: _vm.editChange },
                        model: {
                          value: _vm.editCheck,
                          callback: function ($$v) {
                            _vm.editCheck = $$v
                          },
                          expression: "editCheck",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "content-body" },
                _vm._l(_vm.userList, function (item, index) {
                  return _c("li", { key: index }, [
                    _c("p", { staticClass: "username" }, [
                      _c("img", { attrs: { src: item.card.avatar, alt: "" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.card.name))]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          key: index,
                          attrs: { label: item.downloadCheck },
                          model: {
                            value: item.downloadCheck,
                            callback: function ($$v) {
                              _vm.$set(item, "downloadCheck", $$v)
                            },
                            expression: "item.downloadCheck",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          key: index,
                          attrs: { label: item.editCheck },
                          model: {
                            value: item.editCheck,
                            callback: function ($$v) {
                              _vm.$set(item, "editCheck", $$v)
                            },
                            expression: "item.editCheck",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteShare(index)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("public.delete")))]
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer text-center",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("public.cancel"))),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }